export default function initializeNewSlider() {
    
    let thumbnailHolders = $('.slidermoreimages')
    
    for (let a = 0; a < thumbnailHolders.length; a++) {
        const items = $(thumbnailHolders[a]).children()
        
        hideThumbsIf1($(thumbnailHolders[a]))
        
        let firstLoad = false;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            
            if (firstLoad == false) {
                if (item.className == 'arrow-left') {
                    // do nothing, skip
                } else {
                    load($(item));
                    firstLoad = true;
                }
            }
            $(item).click(function () {
                moveIfNeeded(item);
                load($(item));
            })
        }
    }
}

function load(item) {
    // remove all children first
    var items = item.parent().children();
    $(items).css('border', '');

    const slider = item.parents('.slider').children('.main-slideritem')
    slider.children().remove();

    item.css('border', '2px solid rgba(37, 58, 121, 1)');

    //check if item is video tag or image
    const tagName = item.prop('tagName')

    if (tagName == 'IMG') {
        addChild(tagName, item.attr('src'), slider);
    } else if (tagName == 'DIV') {
        if (item.children('video')[0] != undefined) { 
            let video = item.children('video');
            $(video).get(0).pause();
            let source = $(video).children('source');
            addChild(video[0].tagName, source.attr('src'), slider);
        } else if (item.children('embedded-video')[0] != undefined) {
            let embeddedVideo = item.children('embedded-video')[0];
            addChild('IFRAME', $(embeddedVideo).attr('src'), slider);
        } else {
            console.warn("unsupported tag of div");
        }
    } else if (tagName == 'VIDEO') {   
        item.get(0).pause();
        let source = item.children('source');
        addChild(tagName, source.attr('src'), slider);
    } else {
        console.warn("unsupported tag");
    }
}

function addChild(type, source, slider) {
    if (source != null) {
        if (type == 'IMG') {
            slider.append('<img lb class="main-image" src alt="">');
            slider.children('img').attr('src', source);
        } else if (type == 'VIDEO') {
            slider.append('<video class="main-video" controls></video>');
            slider.children('video').append('<source src>');
            slider.children('video').children('source').attr('src', source);
        } else if (type == 'IFRAME') {
            slider.append('<iframe class="main-iframe" src></iframe>');
            slider.children('iframe').attr('src', source);
        } else {
            console.warn('unsupported type');
        }
    } else {
        console.warn('source is unsupported or null');
    }
}
function moveIfNeeded(item) {
    if (window.innerWidth > 500) {
        var length = $('.slidermoreimages').children().length;
    
        if (length >= 6) {
            var value = $('.slidermoreimages').attr('style');

            if (value == null) {
                value = 0
            } else {
                var transXRegex = /\.*translateX\((.*)px\)/i;
                value = transXRegex.exec(value)[1];
            }
            // make this better 
            if (value == 0) {
                if ($(item).index() == 5) {
                    $('.slidermoreimages').css('transform', 'translateX(-355px)');
                }
            } else if (value == -355) {
                if ($(item).index() == 4) {
                    $('.slidermoreimages').css('transform', 'translateX(0px)');
                } else if ($(item).index() == 10) {
                    $('.slidermoreimages').css('transform', 'translateX(-725px)');
                }
            } else if (value == -725) {
                if ($(item).index() == 9) {
                    $('.slidermoreimages').css('transform', 'translateX(-355px)');
                } else if ($(item).index() == 15) {
                    $('.slidermoreimages').css('transform', 'translateX(-1095px)');
                }
            } else if (value == -1095) {
                if ($(item).index() == 14) {
                    $('.slidermoreimages').css('transform', 'translateX(-725px)');
                } else if ($(item).index() == 20) {
                    $('.slidermoreimages').css('transform', 'translateX(-1465px)');
                }
            } else if (value == -1465) {
                if ($(item).index() == 19) {
                    $('.slidermoreimages').css('transform', 'translateX(-725px)');
                } else if ($(item).index() == 25) {
                    $('.slidermoreimages').css('transform', 'translateX(-1835px)');
                }
            } else if (value == -1835) {
                if ($(item).index() == 24) {
                    $('.slidermoreimages').css('transform', 'translateX(-1465px)');
                }
            }
        }
    }
}

// hides the first item if there is only one.
function hideThumbsIf1(main) {
    var items = main.children()
    if (items[0]) {
        if (items.length === 1) {
            items[0].style.display = 'none'
        } else {
            items[0].style.display = 'block'
        }
    }
}